import { Button } from '@/components/ui/button';
import styles from '../UnifyOnboarding.module.scss';

export const PartnerLeadConnection = ({ provider, onConnect, isLoading, isDisabled }) => {
	if (!provider || provider.connection !== 'partner-lead') {
		return null;
	}

	return (
		<>
			<p className={styles.helperText}>
				We&apos;ve notified {provider.label} about your connection request. They&apos;ll be in touch shortly to complete the setup.
			</p>
			<Button onClick={onConnect} disabled={isLoading || isDisabled} className={styles.submitButton}>
				{isLoading ? 'Submitting...' : 'Submit Request'}
			</Button>
		</>
	);
};
